import styles from './FooterCopyright.module.scss';

interface FooterCopyrightProps {
  text: string;
}

export const FooterCopyright = ({ text }: FooterCopyrightProps) => (
  <p className={`${styles['footer__copyright-p']}`}>{text}</p>
);
